export const sizes = {
  xs: "text-[0.65rem] h-4 p-0",
  sm: "text-xxs h-5 px-2 pt-[2px] pb-[3px]",
  md: "text-xs h-6 py-1 px-[10px]",
  lg: "text-sm h-7 py-1 px-[10px]",
};

export const variants = {
  green: "bg-[#DCFCE7] text-[#15803D]",
  yellow: "bg-chorus-yellow-100 text-chorus-yellow-800",
  red: "bg-[#FEE2E2] text-[#B91C1C] ",
  gray: "bg-[#F1F5F9] text-[#64748B]",
  teal: "bg-chorus-teal-100 text-chorus-teal-600",
  purple: "bg-[#F3E8FF] text-[#9333EA]",
  sky: "bg-[#E0F2FE] text-[#0369A1]",
  slate: "bg-[#F1F5F9] text-[#475569] border-[#E2E8F0] border",
  black: "bg-chorus-black-300 text-white",
  orange: "bg-chorus-orange-50 text-chorus-orange-600",
  // Towers stop-sequence badges
  pink: "bg-[#FCE7F3] text-[#BE185D]",
  lime: "bg-[#ECFCCB] text-[#4D7C0F]",
  tan: "bg-[#F5E6D3] text-[#78350F]",
  indigo: "bg-[#E0E7FF] text-[#4338CA]",
  outline: "bg-white text-chorus-black-100 border border-chorus-gray-500",
};

export const iconVariants = {
  green: "fill-chorus-green-700",
  yellow: "fill-chorus-yellow-700",
  red: "fill-chorus-red-700 ",
  gray: "fill-chorus-gray-800",
  teal: "fill-chorus-teal-500",
  purple: "fill-[#9333EA]",
  sky: "fill-[#0369A1]",
  slate: "fill-chorus-gray-800",
  black: "fill-chorus-black-300",
  orange: "fill-chorus-orange-600",
  // Towers stop-sequence badges
  pink: "fill-[#BE185D]",
  lime: "fill-[#4D7C0F]",
  tan: "fill-[#78350F]",
  indigo: "fill-[#4338CA]",
  outline: "fill-chorus-black-100",
};

export const rounds = {
  xs: "rounded",
  sm: "rounded",
  xl: "rounded-20",
};
